import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Formik } from "formik";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useHistory } from "react-router-dom";

import {
  Label,
  TextBox,
  TextArea,
} from "../../../primitives";
import styles from "./styles.module.scss";
import { model, validation } from "./constant";
import { steps } from "../constant";
import { getUserTeams } from "modules/teams/teams.action";
import NewProjectAccess from "../../../../common/components/newProjectSharedComponents/newProjectAccess";
import NewProjectTeam from "../../../../common/components/newProjectSharedComponents/newProjectTeam";
import NewProjectEvaluation from "../../../../common/components/newProjectSharedComponents/newProjectEvaluation";
import styles1 from "../../../../common/components/fordNewProjectModal/styles.module.scss";
import CheckBox from "modules/admin/adminIdeas/addForm/checkBox";
import CompaniesItem from "modules/themes/themesCommon/newProjectModal/companies/companiesBlock";
import MembersItem from "modules/themes/themesCommon/newProjectModal/members/membersBlock";

const StepOneComponent = (props) => {
  const {
    formRef,
    moveNextStep,
    defultModel,
    mode,
    isPatientOrganization,
    hideGskFromOptions,
    selectedIdea,
  } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [initModel, setInitModel] = useState({ ...model, ...defultModel });

  const isPatientOrg =
    history.location.pathname.indexOf("organizations") !== -1;

  const {
    authReducer: { session },
    councilReducer: { selectedCouncil },
    stepOneReducer: { stageTemplates },
  } = useSelector((state) => state);

  const getDefaultEvalTemplate = () => {
    if (stageTemplates && stageTemplates?.length > 0) {
      if (
        selectedCouncil.name === "GSK" &&
        history.location?.state?.from &&
        (history.location?.state?.from === "/projects" ||
          history.location?.state?.from === "/home")
      ) {
        return stageTemplates.filter(
          (template) => template.default_patient_organization
        )[0]?.id;
      }
      if (selectedCouncil.name === "GSK" && !isPatientOrg) {
        return stageTemplates.filter((template) => template.default_template)[0]
          ?.id;
      }

      if (selectedCouncil.name === "GSK" && isPatientOrg) {
        return stageTemplates.filter(
          (template) => template.default_patient_organization
        )[0]?.id;
      }

      return stageTemplates.filter((template) => template.default_template)[0]
        ?.id;
    }
  };

  const onSubmitValue = (values) => {
    const getSelectedTemplate = stageTemplates.filter(t => t.id === values.stage_template_id) || [];
    const makeStageTemplateObj = {
      val: values.stage_template_id,
      obj: getSelectedTemplate,
    };

    moveNextStep(steps.step_two, {
      ...values,
      stage_template_id: makeStageTemplateObj,
      userId: session.id,
      councilId: selectedCouncil.id,
    });
    // dispatch(projectNew(obj))
  };

  useEffect(() => {
    if (stageTemplates?.length) {
      setInitModel((prev) => ({
        ...prev,
        ...defultModel || {},
        stage_template_id: getDefaultEvalTemplate(),
      }));
    }
  }, [stageTemplates]);

  useEffect(() => {
    const new_project = localStorage.getItem("new_project");
    if (new_project) {
      setInitModel((prev) => ({ ...prev, ...JSON.parse(new_project) }));
    }

    dispatch(
      getUserTeams({
        enqueueSnackbar,
        query: {
          items: 1000,
        },
      })
    );
  }, []);

  const isStuffDisabled = useMemo(() => {
    return selectedCouncil?.traction_tag === "firmenich" &&
      (session?.council_role === "standard" ||
        session?.council_role === "viewer") &&
      !session?.theme_investment_access
  }, [selectedCouncil, session]);

  const getMembers = useMemo(() => {
    if (!selectedIdea?.ideas_members?.length) {
      return [];
    }

    return selectedIdea.ideas_members.filter(m => m.user_id !== session.id);
  }, [session, selectedIdea]);

  const storeCompanies = useCallback((companyId) => {
    const { values, setFieldValue } = formRef.current;

    if (values.selected_company_ids?.includes(companyId)) {
      const filteredArray = values.selected_company_ids
        .filter((selectedCompanyId) => selectedCompanyId !== companyId);

      setFieldValue('selected_company_ids', filteredArray);

      if (filteredArray.length !== selectedIdea.ideas_related_companies.length) {
        setFieldValue('select_all_companies', false);
      }
    } else {
      const findCompany = selectedIdea?.ideas_related_companies
        .find((c) => c.company.id === companyId);

      if (!findCompany) {
        return;
      }
      const ids = [...values.selected_company_ids, findCompany.company.id];

      if (ids.length === selectedIdea.ideas_related_companies.length) {
        setFieldValue('select_all_companies', true);
      }

      setFieldValue('selected_company_ids', ids);
    }
  }, [formRef, selectedIdea]);

  const storeMembers = useCallback((memberId) => {
    const { values, setFieldValue } = formRef.current;

    if (values.selected_member_ids.includes(memberId)) {
      const filteredArray = values.selected_member_ids
        .filter((selectedMemberId) => selectedMemberId !== memberId);

      setFieldValue('selected_member_ids', filteredArray || []);

      if (filteredArray.length !== getMembers.length) {
        setFieldValue('select_all_members', false);
      }
    } else {
      const findMember = getMembers.find((member) => member.user_id === memberId);

      if (!findMember) {
        return;
      }

      const ids = [...values.selected_member_ids, findMember.user_id];

      if (ids.length === getMembers.length) {
        setFieldValue('select_all_members', true);
      }

      setFieldValue('selected_member_ids', [...values.selected_member_ids, findMember.user_id]);
    }
  }, [formRef, getMembers]);

  const selectAllCompanies = useCallback(() => {
    const newValue = !formRef?.current?.values?.select_all_companies
    formRef.current.setFieldValue('select_all_companies', newValue);

    if (!newValue) {
      formRef.current.setFieldValue('selected_company_ids', []);
    } else {
      formRef.current.setFieldValue('selected_company_ids', selectedIdea?.ideas_related_companies.map(c => c.company.id));
    }
  }, [formRef, selectedIdea]);

  const selectAllMembers = useCallback(() => {
    const newValue = !formRef.current?.values?.select_all_members
    formRef.current.setFieldValue('select_all_members', newValue);

    if (!newValue) {
      formRef.current.setFieldValue('selected_member_ids', []);
    } else {
      formRef.current.setFieldValue('selected_member_ids', getMembers.map(member => member.user_id));
    }
  }, [formRef, getMembers]);

  return (
    <div className={styles.inner}>
      {mode !== "modal" && (
        <h4 className={classNames("bold", styles.innerTitle)}>
          Create Project
        </h4>
      )}
      <Formik
        innerRef={formRef}
        enableReinitialize
        initialValues={initModel}
        validationSchema={validation}
        onSubmit={(values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          onSubmitValue(values);
          resetForm();
        }}
      >
        {({ handleSubmit, ...formikprops }) => (
          <form onSubmit={handleSubmit}>
            <div className={styles.formElement}>
              <Label>Project name</Label>
              <TextBox
                type="text"
                name="name"
                placeholder="Project name"
                formProps={formikprops}
                className={styles.textBox}
              />
            </div>
            <div className={styles.formElement}>
              <NewProjectAccess
                formikprops={formikprops}
                isDisabled={isStuffDisabled}
              />
            </div>
            {formikprops.values.visibility === "team" && (
              <div className={styles.formElement}>
                <NewProjectTeam setFieldValue={formikprops.setFieldValue} />
              </div>
            )}
            <NewProjectEvaluation
              formikprops={formikprops}
              isDisabled={isStuffDisabled}
              hideGskFromOptions={hideGskFromOptions}
              isPatientOrganization={isPatientOrganization}
              mode={mode}
            />
            <div className={styles.formElement}>
              <Label>Problem Statement</Label>
              <TextArea
                type="text"
                name="description"
                placeholder="Describe the problem you are trying to solve, the project goal, or description."
                className={styles.textBox}
                formProps={formikprops}
                rows={8}
              />
            </div>
            {
              selectedIdea?.id && (
                <div>
                  {
                    selectedIdea?.ideas_related_companies?.length > 0 ? (
                      <>
                        <Label>Select company</Label>
                        <div className={styles1.selectAllCompanies}>
                          <Label>Select all companies</Label>
                          <CheckBox
                            onChange={selectAllCompanies}
                            className={styles1.selectCompCheckbox}
                            isChecked={formRef?.current?.values?.select_all_companies}
                          />
                        </div>
                        <div className={styles1.companiesBlockContainer}>
                          {
                            selectedIdea?.ideas_related_companies.filter(c => !c.is_product).map((company) => (
                              <div key={`${company.company.id}`}>
                                <CompaniesItem
                                  storeCompanies={storeCompanies}
                                  company={{
                                    ...company.company,
                                    company_id: company.company.id
                                  }}
                                  selectAllCompanies={formRef?.current?.values?.select_all_companies}
                                  selected={formRef?.current?.values?.selected_company_ids?.includes(company.company.id)}
                                />
                              </div>
                            ))
                          }
                        </div>
                      </>
                    ) : null
                  }
                  {
                    getMembers?.length > 0 ? (
                      <div className="mt-3 mb-3">
                        <Label>Select member</Label>
                        <div className={styles1.selectAllCompanies}>
                          <Label>Select all members</Label>
                          <CheckBox
                            onChange={selectAllMembers}
                            className={styles1.selectMemberCheckbox}
                            isChecked={formRef?.current?.values?.select_all_members}
                          />
                        </div>
                        <div className={styles1.membersBlockContainer}>
                          {
                            getMembers.map((member) => (
                              <div
                                key={`${member.user_id}`}
                                className={styles1.companiesBlockItem}
                              >
                                <MembersItem
                                  storeMembers={storeMembers}
                                  member={{
                                    ...member,
                                    avatar: member.user_avatar,
                                    name: member.user_first_name
                                  }}
                                  selectAllMembers={formRef?.current?.values?.select_all_members}
                                  selected={formRef?.current?.values?.selected_member_ids?.includes(member.user_id)}
                                />
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    ) : null
                  }
                </div>
              )
            }
          </form>
        )}
      </Formik>
    </div>
  );
};

export default React.memo(StepOneComponent);
